import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    //#region Fields

    private _visible: boolean = false;
    private _indicatorSourceFileUrl = '';
    isLoading: any;

    //#endregion

    //#region Properties

    get visible(): boolean {
        return this._visible;
    }

    get indicatorUrl() {
        return this._indicatorSourceFileUrl;
    }

    //#endregion

    //#region Methods

    show() {
        this._visible = true;
    }

    hide() {
        this._visible = false;
    }

    setIndicatorSourceUrl(url: string) {
        if (!url)
            return;
        this._indicatorSourceFileUrl = url;
    }

    setDefaultIndicatorSourceUrl() {
        this._indicatorSourceFileUrl = 'assets/loader/loaderBig.gif'
    }

    //#endregion
}
